import { render, staticRenderFns } from "./IndexCoreano.vue?vue&type=template&id=f37154be&"
import script from "./IndexCoreano.vue?vue&type=script&lang=js&"
export * from "./IndexCoreano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports